module.exports = __webpack_public_path__ + "img/deepwater-green4.a928c4f9.png";